import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';

import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { PolicyDetailsService } from '../services/policydetails.service';

@Component({
  selector: '',
  template: '',
})
export class PremiumPaidHistorySearchHandler extends BaseSearchComponent<PolicyDetailsService> implements OnInit {
  public searchName: string;
  isAdvanceSearchDisplayed: boolean;

  constructor(
    public service: PolicyDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
    this.addLink = '/search-premium-paid-history';
    //this.service.isAuditButtonClicked = false;
    // this.isSearchFilteredByCriteria = true;
  }

  ngOnInit() {
    super.ngOnInit();
    this.searchName = 'SearchPremiumPaidHistory';
    //this.service.forAuditSearchList = false;
    this.settingService.removeSessionStorage('AuditChanges');
    this.isAdvanceSearchDisplayed = true;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Search',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Edit',
        link: '/search-premium-paid-history',
      },
      {
        id: 'Delete',
        link: '/search-premium-paid-history',
      },
      {
        id: 'Audit',
        link: '/search-premium-paid-history',
      },
      {
        id: 'Close',
        link: '/search-premium-paid-history',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    // header.title = 'Premium Paid History';
    header.title = this.settingService.getLabelValue('premiumPaidHistory');
    return header;
  }

  Edit_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link]);
  }

  Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
    this.service.id = buttonClicked.ref_id;
    setTimeout(() => {
      //this.service.isAuditButtonClicked = true;
    }, 10);
  }
}
